import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";

interface AppHeaderProps {
  onClose?: () => void;
  title: string;
}

export const AppHeader = ({ onClose, title }: AppHeaderProps) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonTitle color="white">{title}</IonTitle>
        {onClose && (
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={closeOutline} color="white" />
            </IonButton>
          </IonButtons>
        )}
      </IonToolbar>
    </IonHeader>
  );
};
